module.exports = __webpack_public_path__ + "static/img/logo-OB.83680ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/awardTW/img/logo-OB.png
// module id = +Yih
// module chunks = 1